enum Mutation {
  SET_SHIFTS = 'setShifts',
  UPDATE_SHIFTS = 'updateShifts',
  DELETE_SHIFTS = 'deleteShifts',
}

export default Mutation;
